import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

import { ref, onMounted, useAttrs } from 'vue'

const __default__ = { name: 'CosTextareaView' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: {
    type: [String, Number]
  }
},
  setup(__props) {

const attrs = useAttrs()

const minH = ref(52)
onMounted(() => {
  const autoSize: any = attrs.autoSize
  const row: any = attrs.row
  if (autoSize && autoSize.minRows) {
    minH.value = autoSize.minRows * 32 + 8
  }
  if (row) {
    minH.value = row * 32 + 8
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "cos-form-item-detail cos-form-item-txtarea-detail",
    style: _normalizeStyle({ minHeight: minH.value + 'px' })
  }, [
    _createElementVNode("p", { title: __props.value }, _toDisplayString(__props.value == null || __props.value === '' ? '--' : __props.value), 9, _hoisted_1)
  ], 4))
}
}

})